import { render, staticRenderFns } from "./SettingDetail.vue?vue&type=template&id=07824b15&scoped=true"
import script from "./SettingDetail.vue?vue&type=script&lang=js"
export * from "./SettingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07824b15",
  null
  
)

export default component.exports